import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import React, { createRef, useEffect, useRef } from "react";

import clientComponent from "../config/clientComponents";

const Institution = ({
  data,
  selectedInstitution,
  setSelectedInstitution,
  client,
  filters,
  setMapScreen,
  setScrollbarRef,
  lineRefs,
  filtersKeys,
}) => {
  let etablissements = [];
  //--- Needed to give the overlay scrollbar instance to InstitutionItem
  const scrollbarRef = useRef(null);

  //--- Dynamic import
  const InstitutionItem = clientComponent["InstitutionItem"];

  useEffect(() => {
    setScrollbarRef(scrollbarRef);
  }, [, data]);

  etablissements = data.map((etablissement, i) => {
    return (
      <InstitutionItem
        key={etablissement.id}
        etablissement={etablissement}
        selectedInstitution={selectedInstitution}
        setSelectedInstitution={setSelectedInstitution}
        filters={filters}
        setMapScreen={setMapScreen}
        scrollbarRef={scrollbarRef}
        allEtablissements={data}
        ref={lineRefs.current[i]}
        filtersKeys={filtersKeys}
      />
    );
  });

  return (
    <div className="institution">
      <OverlayScrollbarsComponent
        className="overlay-scrollbar os-theme-dark"
        options={{
          overflowBehavior: {
            x: "hidden",
            y: "scroll",
          },
        }}
        ref={scrollbarRef}
      >
        {etablissements}
      </OverlayScrollbarsComponent>
    </div>
  );
};

export default Institution;
